export default __webpack_public_path__ + "static/media/plus.58994647.svg";